import { cx } from '@orn/shared-web/utils/cx';
import { NavLink } from 'react-router-dom';

import { PATHS } from '../../paths';

interface IWorkItemsNavItem {
  label: string;
  to: string;
}

const ITEMS: IWorkItemsNavItem[] = [
  { label: 'Items', to: PATHS.WORK_ITEMS_LIST },
  { label: 'Schedules', to: PATHS.WORK_ITEM_SCHEDULES },
];

/**
 * Sub-tab strip for the Work items tool. New sub-tabs are added by appending to
 * `ITEMS`. A thin local component with one consumer, mirroring `AssistantNav`.
 */
const WorkItemsNav = () => (
  <nav className="border-border-primary flex gap-1 border-b text-xs uppercase tracking-wider">
    {ITEMS.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        className={({ isActive }) =>
          cx(
            '-mb-px border-b-2 px-3 py-2 font-medium transition-colors',
            isActive
              ? 'text-fg-brand-primary border-fg-brand-primary'
              : 'text-fg-secondary hover:text-fg-primary border-transparent'
          )
        }
      >
        {item.label}
      </NavLink>
    ))}
  </nav>
);

export default WorkItemsNav;
